<div class="delete-vip-modal-root">
  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  <div class="header">
    <div class="title">{{ labelToShow.title }}</div>
  </div>
  <div class="body">
    <p class="text-warning">
      {{ labelToShow.warning }}
    </p>
    <p class="text-info">
      {{ labelToShow.info }}
    </p>
    <p class="text-danger">
      {{ labelToShow.danger }}
    </p>
  </div>
  <div class="footer">
    <button mat-stroked-button color="primary" (click)="onDialogClose()">
      {{ labelToShow.cancel }}
    </button>
    <button mat-flat-button color="warn" (click)="changeMarkToDeleteBusinessLevel()"
            [ngClass]="data.markedForDeletion ? 'btn-unmark' : 'btn-delete'">
      <nb-icon icon="{{ data.markedForDeletion ? 'checkmark' : 'trash-2-outline' }}"></nb-icon>
      <span>{{ labelToShow.action }}</span>
    </button>
  </div>
</div>
